import { defineListenerProp } from "../utils/components.mjs";
const props = {
  disabled: Boolean,
  readonly: Boolean,
  scrollToError: String,
  scrollToErrorOffsetY: {
    type: [String, Number],
    default: 0
  },
  onSubmit: defineListenerProp(),
  onReset: defineListenerProp()
};
export {
  props
};
